import { IconContainer } from "@src/components/helper.styled";

const AliasIcon = () => {
	return (
		<IconContainer>
			<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M3 4.5H10.5"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M3 9H15"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M3 13.5H10.5"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<circle cx="13.5" cy="4.5" r="1.75" stroke="white" strokeWidth="1.5" />
				<circle cx="13.5" cy="13.5" r="1.75" stroke="white" strokeWidth="1.5" />
			</svg>
		</IconContainer>
	);
};

export default AliasIcon;
